<template>
    <div>
        <textarea :id="id" v-text="text" class="form-control"></textarea>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import Cookies from 'js-cookie'
export default {
    name: 'TextEditor',
    emits: ['update:text'],
    data() {
        return {
            editor: null
        }
    },
    props: {
        text: String,
        id: String
    },
    updated() {
        if (this.editor.getData() !== this.text)
            this.editor.setData(this.text);
    },
    computed: {
        ...mapGetters({
            customer: 'auth/getUser'
        })
    },
    mounted() {
        this.editor = window.CKEDITOR.replace(this.id, {
            filebrowserImageBrowseUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm?type=Images&token=' + Cookies.get('auth_token'),
            filebrowserImageUploadUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm/upload?type=Images&_token=&token=' + Cookies.get('auth_token'),
            filebrowserBrowseUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm?type=Files&token=' + Cookies.get('auth_token'),
            filebrowserUploadUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm/upload?type=Files&_token=&token=' + Cookies.get('auth_token'),
        });

        this.editor.on('change', () => {
            this.$emit('update:text', this.editor.getData())
        });
    }
}
</script>
